import React from 'react';
import PropTypes from 'prop-types';
import { Provider as ModalPortalContextProvider } from './modal-portal';
import Hotkeys from '../../components/modal-portal/non-authed-hotkeys';

export const UnauthedModalPortalContextProvider = ({ children }) => {
  return <ModalPortalContextProvider hotkeyValue={{ Hotkeys }}>{children}</ModalPortalContextProvider>;
};

UnauthedModalPortalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
